import type { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { useProductOfferings } from '../ConciergeServiceSection/useProductOfferings';
import type { GalleryItemData } from './components/GalleryItem/GalleryItem';
import { useCallback } from 'react';
import { useCachedRandom } from './useCachedRandom';
import { isConciergeServiceCategory } from '@apps/card/routes/Concierge/config';

// Index of first Concierge card
const FIRST_CONCIERGE_INDEX = 10;
// Base interval between cards
const CONCIERGE_INTERVAL = 7;
// + variation from CONCIERGE_INTERVAL
const CONCIERGE_VARIATION = 2;
const useConciergeTiles = (category: StationeryTemplateCategoryEnum) => {
  const cachedRandom = useCachedRandom({ deps: [category] });
  const { productOfferings } = useProductOfferings();

  const injectTiles = useCallback(
    (tiles: GalleryItemData[], category: StationeryTemplateCategoryEnum) => {
      if (!isConciergeServiceCategory(category)) {
        return tiles;
      }
      const tilesWithConcierge = [...tiles].map(t => t);

      const products = productOfferings[category];
      let insertionIndex = FIRST_CONCIERGE_INDEX;
      products.forEach((product, productsIndex) => {
        const variance = Math.floor(cachedRandom(productsIndex) * 10) % (CONCIERGE_VARIATION + 1);
        if (productsIndex !== 0) {
          insertionIndex += CONCIERGE_INTERVAL + variance;
        }
        tilesWithConcierge.splice(insertionIndex, 0, { ...product, index: productsIndex, type: 'concierge' });
      });

      return tilesWithConcierge;
    },
    [cachedRandom, productOfferings],
  );

  return injectTiles;
};

export default useConciergeTiles;
